module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class=\'accordion\' style=\'margin-bottom: 0;\'>\n    <div class=\'accordion-group\'>\n        <div class=\'accordion-heading\'>\n            <div class=\'accordion-toggle\'>&nbsp;</div>\n        </div>\n        <div class=\'accordion-body\'>\n            <div class=\'accordion-inner\'>\n                <dl class=\'stepped zero\'>\n                    <dt>ID</dt>\n                    <dd>' +
((__t = ( id )) == null ? '' : __t) +
'</dd>\n                    <dt>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</dt>\n                    <dd>' +
((__t = ( name )) == null ? '' : __t) +
'</dd>\n                    <dt>' +
((__t = ( i18next.t('glossary.configuration') )) == null ? '' : __t) +
'</dt>\n                    <dd>' +
((__t = ( configurationName )) == null ? '' : __t) +
'</dd>\n                    <dt>' +
((__t = ( i18next.t('glossary.site') )) == null ? '' : __t) +
'</dt>\n                    <dd><a href="' +
((__t = ( site.nodeUrl() )) == null ? '' : __t) +
'">' +
((__t = ( site.get('name') )) == null ? '' : __t) +
'</a></dd>\n                    <dt>' +
((__t = ( i18next.t('integrations.reference_indicator') )) == null ? '' : __t) +
'</dt>\n                    <dd><a href="' +
((__t = ( indicator.nodeUrl() )) == null ? '' : __t) +
'">' +
((__t = ( indicator.get('name') )) == null ? '' : __t) +
'</a></dd>\n                    <dt>' +
((__t = ( i18next.t('integrations.last_run_at') )) == null ? '' : __t) +
'</dt>\n                    <dd>' +
((__t = ( last_run_at ? WiseMetering.utils.formatDate(last_run_at) : '-' )) == null ? '' : __t) +
'</dd>\n                    <dt>' +
((__t = ( i18next.t('common.creation') )) == null ? '' : __t) +
'</dt>\n                    <dd>' +
((__t = ( WiseMetering.utils.formatDate(created_at) )) == null ? '' : __t) +
' - ' +
((__t = ( creator_name )) == null ? '' : __t) +
'</dd>\n                    <dt>' +
((__t = ( i18next.t('glossary.last_change') )) == null ? '' : __t) +
'</dt>\n                    <dd>' +
((__t = ( WiseMetering.utils.formatDate(updated_at) )) == null ? '' : __t) +
' - ' +
((__t = ( updater_name )) == null ? '' : __t) +
'</dd>\n                </dl>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
}